import { useState } from "react";

type PalletStackerCraneControlsProps = {
  disabled?: boolean;
  initialHeight: number;
  onHeightChange: (height: number) => void;
};

export function PalletStackerCraneControls({
  disabled = false,
  initialHeight,
  onHeightChange
}: PalletStackerCraneControlsProps) {
  const [heightDraft, setHeightDraft] = useState(String(initialHeight));

  return (
    <div className="pallet-stacker-crane-controls">
      <span className="pallet-stacker-crane-controls-title">托盘堆垛机</span>
      <label className="pallet-stacker-crane-controls-field">
        <span>立柱高度</span>
        <span className="pallet-stacker-crane-controls-input-wrap">
          <input
            disabled={disabled}
            inputMode="decimal"
            min="0.001"
            onChange={(event) => {
              const nextDraft = event.target.value;
              const nextValue = Number(nextDraft);
              setHeightDraft(nextDraft);
              if (Number.isFinite(nextValue) && nextValue > 0) {
                onHeightChange(nextValue);
              }
            }}
            step="0.01"
            type="number"
            value={heightDraft}
          />
          <span>m</span>
        </span>
      </label>
    </div>
  );
}
